import React from 'react';

import { TIME_WINDOW_OPTIONS, TimeWindowKey } from './chartHelpers';

interface Props {
  value: TimeWindowKey;
  onChange: (next: TimeWindowKey) => void;
  className?: string;
  ariaLabel?: string;
}

const TimeWindowSelector: React.FC<Props> = ({
  value,
  onChange,
  className,
  ariaLabel = 'Time window',
}) => (
  <div
    role="group"
    aria-label={ariaLabel}
    className={`inline-flex rounded-md border border-gray-200 bg-white text-xs ${className || ''}`}
  >
    {TIME_WINDOW_OPTIONS.map(opt => {
      const active = opt.key === value;
      return (
        <button
          key={opt.key}
          type="button"
          onClick={() => onChange(opt.key)}
          className={`px-2.5 py-1 transition-colors first:rounded-l-md last:rounded-r-md border-r border-gray-200 last:border-r-0 ${
            active
              ? 'bg-blue-600 text-white'
              : 'text-gray-700 hover:bg-gray-50'
          }`}
          aria-pressed={active}
        >
          {opt.label}
        </button>
      );
    })}
  </div>
);

export default TimeWindowSelector;
